import { useStyletron } from 'baseui'
import { SIZE } from 'baseui/input'
import { FormControl } from 'baseui/form-control'
import { Table } from 'baseui/table-semantic'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponents/SDNotification'
import SDInput from '@/shared/components/SDComponents/SDInput/SDInput'
import useContactSearchPage from './useContactSearchPage'

const ContactSearchPage = () => {
  const {
    t,
    triggerSearchClient,
    setPhone,
    redirectWhenSingleResult,
    phoneError,
    searchId,
    loadingResponse,
    result,
    resultError,
  } = useContactSearchPage()
  const [css, theme] = useStyletron()
  const cardStyle = css({
    padding: '1rem',
    marginBottom: '2rem',
    backgroundColor: 'white',
    borderRadius: '1rem',
    boxShadow: '0 2px 6px rgba(20,96,170,.3)',
  })
  const headingStyle = css({
    margin: '1rem 10px 10px 10px',
    color: theme.colors.primary,
    ...theme.typography.HeadingMedium,
  })
  const parent = css({
    display: 'flex',
  })
  const COLUMNS = [
    t('subscriptionForm:contact_search.table.name'),
    t('subscriptionForm:contact_search.table.firstname'),
    t('subscriptionForm:contact_search.table.phone'),
    '',
  ]
  const mapResult = result => {
    return result.map(element => {
      return [
        element.name,
        element.firstname,
        element.phone,
        <SDButton
          key={element.zoho_id}
          onClick={() => {
            redirectWhenSingleResult(element)
          }}
        >
          {t('subscriptionForm:contact_search.choose')}
        </SDButton>,
      ]
    })
  }

  return (
    <>
      <div className={parent}>
        <div className={cardStyle}>
          <h1 className={headingStyle}>{t('subscriptionForm:contact_search.panel_name')}</h1>
          <FormControl error={phoneError ?? ''} label={<span>{t('subscriptionForm:contact_search.phone_label')}</span>}>
            <SDInput
              size={SIZE.compact}
              placeholder={t('subscriptionForm:contact_search.phone_label')}
              autoComplete='off'
              onBlur={event => setPhone(event.target.value)}
            />
          </FormControl>
          <SDButton block onClick={triggerSearchClient} isLoading={loadingResponse} disabled={loadingResponse}>
            {t('subscriptionForm:contact_search.button')}
          </SDButton>
          {searchId && loadingResponse && (
            <SDNotification type='positive'>{t('subscriptionForm:contact_search.request_saved')}</SDNotification>
          )}
        </div>
      </div>
      {resultError && <SDNotification type='warning'>{resultError}</SDNotification>}
      {result && resultError === null && result.length > 0 && (
        <div className={parent}>
          <div className={cardStyle}>
            <Table columns={COLUMNS} data={mapResult(result)} />
          </div>
        </div>
      )}
    </>
  )
}

export default ContactSearchPage
